import { render, staticRenderFns } from "./Creditors.vue?vue&type=template&id=6aaad414&scoped=true"
import script from "./Creditors.vue?vue&type=script&lang=ts"
export * from "./Creditors.vue?vue&type=script&lang=ts"
import style0 from "./Creditors.vue?vue&type=style&index=0&id=6aaad414&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaad414",
  null
  
)

export default component.exports